import { createFileRoute } from "@tanstack/react-router"
import { ReactElement } from "react"
import BlogPage from "~/components/Blog/BlogPage"
import MarketingLayout from "~/layouts/MarketingLayout"
import type { Post } from "~/components/Blog/types"

function Blog() {
  const { slug } = Route.useParams()
  // TODO: Fetch post data based on slug - this would need to be implemented
  // For now, return a placeholder
  const post: Post | null = null
  // Pass the post data down to the BlogPage component
  if (!post) {
    // Handle case where post is not found (though getServerSideProps should handle this)
    return <div className="flex items-center justify-center h-screen">Post not found.</div>
  }
  return <BlogPage post={post} />
}

function BlogWrapper() {
  return (
    <MarketingLayout>
      <Blog />
    </MarketingLayout>
  )
}

export const Route = createFileRoute("/blog/$slug")({
  component: BlogWrapper,
})
